import React from "react";
import {
  contest_percentage,
  contest_timer,
  contest_type,
  participants,
  timer_icon,
} from "../utils/images";
import { TimerApp } from "./timer";
import { useSelector } from "react-redux";
import { StyleSheet, Text, View } from "react-native";
import { globalFontStyle, Font } from "../assets";
import Colors from "../assets/Color/Colors";
import FastImage from "../common/FastImage";
import moment from "moment/moment";
import FormTextLabel from "./FormTextLabel";
import {GlobalScreens} from "../utils/globalConstant";
function TimerComp({
  isHome,
  customStyle,
  start_time,
  end_time,
  type,
  percentage,
  noTimer = true,
  children,
  isNewFormat,
  participant,
  timerExpireCallback = () => {},
}) {
  let globalConfigData = useSelector(
    (state) => state.utilReducer.globalConfigData
  );

  const showTimer = globalConfigData?.showtimer;
  const timerStart = globalConfigData?.timerstart;
  const parsedDeadline = Date.parse(end_time) - Date.now();
  const showStartTime = Date.parse(start_time) > Date.now();
  const parsedContestDeadline = showStartTime
    ? Date.parse(start_time) - Date.now()
    : Date.parse(end_time) - Date.now();
  const timerContestStart = 3600000 * 24;

  const timeLagFromStartTime = (date) => {
    var seconds = Math.abs(moment().diff(date, "seconds"));
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);
    let addS = true;
    let dt, dtf;
    if (d >= 1) {
      if (d == 1) {
        addS = false;
      }
      dt = `${d} day`;
    } else if (h < 24 && h >= 1) {
      if (h == 1) {
        addS = false;
      }
      dt = `${h} hour`;
    } else if (h < 1 && m >= 1) {
      if (m == 1) {
        addS = false;
      }
      dt = `${m} minute`;
    } else if (m < 1 && s >= 5) {
      dt = `${s} second`;
    } else if (s < 5 && s > 0) {
      addS = false;
      dt = "now";
    } else if (s <= 0) {
      addS = false;
      dt = `${date}`;
    }

    if (addS) {
      dtf = dt + "s";
    } else {
      dtf = dt;
    }
    return dtf;
  };

  return (
    <>
      {showTimer &&
      parsedDeadline > 0 &&
      parsedDeadline < timerStart &&
      isHome === "home" ? (
        <View style={[styles.timerCompHome, customStyle]}>
          {!customStyle?.isStrip && (
            <>
              <FastImage style={{ width: 15, height: 15 }} source={timer_icon()} />
              <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSubText,
                  color: GlobalScreens.Event.InvestedTxt,
                }}
                label={"Ends in: "}
              />
            </>
          )}
          <TimerApp
            deadline={end_time}
            timerExpireCallback={timerExpireCallback}
            customStyle={customStyle?.isStrip ? { 
              color: '#FFFFFF',
              ...globalFontStyle.appFontSubText,
              fontSize: Font.fontSize10,
              fontWeight: '600',
              letterSpacing: -0.04,
            } : undefined}
          />
        </View>
      ) : null}
      {showTimer && isHome === "contest" ? (
        <View style={[styles.timerCompHome, customStyle]}>
          {!showStartTime ? (
            <Text
              style={{
                paddingHorizontal: 8,
                paddingVertical: 2,
                backgroundColor: Colors.red,
                color: Colors.bgWhite,
                borderRadius: 5,
                marginRight: 4,
                ...globalFontStyle.appFontSmallText,
              }}
            >
              Live
            </Text>
          ) : (
            <FastImage
              style={{ width: 15, height: 15 }}
              source={timer_icon()}
            />
          )}
          <Text
            style={{
              ...globalFontStyle.appFontSubText,
              color: Colors.tradexBlue,
            }}
          >
            {showStartTime ? "Starts in" : "Ends in"}&nbsp;
          </Text>
          {parsedContestDeadline < timerContestStart ? (
            <TimerApp deadline={showStartTime ? start_time : end_time} />
          ) : (
            <Text
              style={{
                ...globalFontStyle.appFontSubText,
                color: Colors.tradexBlue,
              }}
            >
              {timeLagFromStartTime(
                moment
                  .utc(showStartTime ? start_time : end_time)
                  .local()
                  .format("MMMM DD, YYYY hh:mm a")
              )}
            </Text>
          )}
          {/*)}*/}
        </View>
      ) : null}
      {showTimer && isHome === "contestDetails" ? (
        <>
          {!isNewFormat ? (
            <View style={[styles.timerContest, customStyle]}>
              {participant && participant > 50 ? (
                <View style={{ flex: 1, flexDirection: "row", gap: 5 }}>
                  <FastImage
                    style={{ width: 15, height: 15 }}
                    source={participants()}
                  />
                  <FormTextLabel
                      labelStyles={{
                        ...globalFontStyle.appFontSubText,
                        color: Colors.lightgrey,
                      }}
                      label={participant > 1 ? "players" : "player"}
                      rest={{participant: participant}}
                  />
                </View>
              ) : null}
              {!showStartTime && parsedContestDeadline > 0 && (
                <FormTextLabel
                    labelStyles={{
                      paddingHorizontal: 8,
                      paddingVertical: 2,
                      backgroundColor: Colors.red,
                      color: Colors.bgWhite,
                      borderRadius: 5,
                      ...globalFontStyle.appFontSmallText,
                    }}
                    label={"Live"}
                />
              )}
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                  gap: 5,
                  justifyContent: "flex-end",
                }}
              >
                {noTimer && (
                  <>
                    <FastImage
                      style={{ width: 15, height: 15 }}
                      source={contest_timer()}
                    />
                    <FormTextLabel
                      labelStyles={{
                        ...globalFontStyle.appFontSubText,
                        color: Colors.lightgrey,
                      }}
                      label={showStartTime ? "Starts in" : "Ends in"}
                    />
                    {parsedContestDeadline < timerContestStart ? (
                      <TimerApp
                        deadline={showStartTime ? start_time : end_time}
                        timerExpireCallback={timerExpireCallback}
                      />
                    ) : (
                      <Text
                        style={{
                          ...globalFontStyle.appFontSubText,
                          color: Colors.tradexBlue,
                        }}
                      >
                        {timeLagFromStartTime(
                          moment
                            .utc(showStartTime ? start_time : end_time)
                            .local()
                            .format("MMMM DD, YYYY hh:mm a")
                        )}
                      </Text>
                    )}
                  </>
                )}
              </View>
            </View>
          ) : (
            <View style={[styles.timerContest, customStyle]}>{children}</View>
          )}
        </>
      ) : null}
      {isHome === "event" &&
      showTimer &&
      parsedDeadline > 0 &&
      parsedDeadline < timerStart ? (
        <View style={styles.timerCompEvent}>
          <FastImage style={{ width: 15, height: 15 }} source={timer_icon()} />
          <FormTextLabel
            labelStyles={{
              ...globalFontStyle.appFontSubText,
              color: GlobalScreens.Event.InvestedTxt,
            }}
            label={"Ends in: "}
          />
          <TimerApp deadline={end_time} />
        </View>
      ) : null}
    </>
  );
}

export default React.memo(TimerComp);

const styles = StyleSheet.create({
  timerCompHome: {
    gap: 5,
    alignItems: "center",
    borderTopWidth: 0.5,
    borderTopColor: Colors.lightgrey1,

    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: GlobalScreens.Event.InvestedBox,
    paddingVertical: 8,
    paddingHorizontal: 15,
    marginTop: 15,
    marginBottom: -15,
    marginHorizontal: -15,
    flexDirection: "row",
    justifyContent: "center",
  },
  timerCompEvent: {
    gap: 5,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: GlobalScreens.Event.InvestedBox,
    flexDirection: "row",
    // width: auto,
    // height: auto,
    //marginHorizontal: -18,
    paddingVertical: 8,
  },
  timerContest: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    borderRadius: 5,
    backgroundColor: Colors.grey3,
    paddingVertical: 10,
    alignItems: "center",
    paddingHorizontal: 15,
  },
});
